//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQCard from "@/components/Generics/AQCard";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import ApplicationDetails from "@/components/apps/ApplicationDetailsCard/ApplicationDetailsCard.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";

export default {
    name: "ViewAQCard",
    components: {
        AQCard,
        AQDropdown,
        ApplicationDetails,
        AQRadio
    },
    data() {
        return {
            testModel: null,
            labelText: "Label",
            option: false,
            ceva: "one",
            clickValue: "one",
            clickValue1: "two",
            clickValue2: "three",
            clickValue1bool: false,
            clickValue2bool: true,
            ceva2: false,
            currentApp: {
                blockchainEnabled: false,
                blockchainType: null,
                description: "",
                imageUrl: null,
                modifiedOn: "2020-08-21T13:24:41.704391",
                name: "001",
                owner: "Admin Admin",
                publishStatus: "PUBLISHED",
                type: "GF"
            },
            ddlFullProps: {
                addSearch: false,
                avatarRounded: true,
                clearable: false,
                clearableChip: false,
                defaultValue: "12",
                disable: false,
                error: false,
                errorLabel: "",
                fitParentContainer: false,
                hasAvatar: false,
                hasCheckbox: false,
                isMultiselect: false,
                label: "",
                options: [
                    {
                        svgIcon: {
                            name: "/assets/img/Approval Matrix.fa28243b.svg",
                            size: "16px"
                        },
                        value: "1",
                        label: "full props and a logn name for this one to check",
                        badgeProps: { badgeText: "qwe" },
                        leftIcon: { name: "add", size: "12px", color: "red" },
                        avatarProps: { type: "platformManager" },
                        tooltipProps: { tooltipContent: "test2131231L" },
                        chipProps: { type: "user", content: "someUser" }
                    },
                    {
                        value: "1",
                        label: "test2131231LONGTestAndsomeMore text",
                        badgeProps: { badgeText: "qwe" },
                        rightIcon: { name: "add", size: "12px", color: "red" },
                        avatarProps: { type: "userPlatform" },
                        itemDisabled: false,
                        tooltipProps: {
                            tooltipContent: "test2131231LONGTestAndsomeMore text"
                        }
                    },
                    {
                        value: "12",
                        label: "test2",
                        rightIcon: { name: "add", size: "18px", color: "blue" },
                        avatarProps: { type: "applicationSpecific" }
                    },
                    {
                        value: "3",
                        label: "test3",
                        rightIcon: { name: "edit" },
                        avatarProps: { type: "externalGroup" }
                    },
                    {
                        value: "4",
                        label: "test4",
                        rightIcon: { name: "mdi-account-circle" },
                        avatarProps: { type: "userPlatform" },
                        chipProps: { content: "qwerty" },
                        description: "other description"
                    },
                    {
                        value: "5",
                        label: "qwerty1",
                        avatarProps: { type: "userPlatform" },
                        chipProps: {
                            content: "qwerty",
                            innerContent: "Class",
                            type: "m_datamodel"
                        },
                        description: "one description"
                    },
                    {
                        value: "6",
                        label: "qwerty22",
                        avatarProps: { type: "externallySetManager" },
                        description: "one description to see how it works , and its a veryl long one too see this too",
                        chipProps: { content: "qwerty" },
                        rightIcon: { name: "mdi-account-circle" }
                    }
                ],
                placeholder: "",
                readonly: false,
                resetSelectedData: false,
                rounded: false
            },
            cardSelectedProps: [],
            cardsModel: [],
            cardPropsAll: {
                label: "This is the title This is the title This is the title This is the title",
                sublabel: "This is the subtitle This is the subtitle This is the subtitle This is the subtitle This is the subtitle This is the subtitle",
                sublabelLines: "1",
                labelLines: "1",
                icon: "timer_off_24px",
                iconColor: "red",
                rightIcon: "edit_24px",
                rightIconColor: "blue",
                style: "",
                headerStyle: "",
                expandIconToggle: true,
                disableExpand: true,
                fullFlex: true,
                alignTop: true,
                disable: true,
                avatarProps: {
                    avatarDisabled: false,
                    customAvatar: null,
                    hasUserNotification: true,
                    isEditable: false,
                    rounded: true,
                    size: 36,
                    type: "platformSetManager"
                },
                checkboxProps: {
                    indeterminate: false,
                    isDisabled: false,
                    label: "",
                    val: ""
                },
                chipProps: {
                    small: true,
                    backgroundColor: "'#4285F4'",
                    textColor: "'#FFF'",
                    fontSize: 10,
                    content: "10"
                },
                chipPropsRight: {
                    small: true,
                    backgroundColor: "'#4285F4'",
                    textColor: "'#FFF'",
                    fontSize: 10,
                    content: "chip chip"
                },
                toggleProps: {
                    checkedIcon: "notifications",
                    uncheckedIcon: "notifications_off"
                },
                menuProps: {
                    options: [
                        {
                            label: "option 1"
                        },
                        {
                            label: "option 2"
                        },
                        {
                            label: "option 3"
                        },
                        {
                            label: "option 4"
                        }
                    ]
                },
                badgeProps: {}
            }
        };
    },
    computed: {
        computedCardPropsAll() {
            return Object.keys(this.cardPropsAll);
        },
        computedCardProps() {
            return this.cardSelectedProps.reduce((acc, item) => ({ ...acc, [item]: this.cardPropsAll[item] }), {});
        }
    },
    watch: {},
    methods: {
        log(data) {
            console.log(JSON.stringify(data));
        }
    }
};
